import { notificationError as notifyError } from 'app/core/toast';
import { messages, messagesKey } from 'app/modules/translation';
import axios from 'axios';
//const t = (x: any) => i18next.t(x);

const getBusinessErrorMessage = (error: any): string | undefined =>
  error?.ErrorMessage ?? error?.errorMessage;

const getResponseMessages = (data: any): Array<string> => {
  const errors = data?.errors;

  if (Array.isArray(errors)) {
    return errors.map(getBusinessErrorMessage).filter(Boolean) as Array<string>;
  }

  if (errors && typeof errors === 'object') {
    return Object.values(errors)
      .flatMap((value: any) => (Array.isArray(value) ? value : [value]))
      .filter((value): value is string => typeof value === 'string' && value.length > 0);
  }

  return [data?.detail, data?.title].filter(
    (value): value is string => typeof value === 'string' && value.length > 0
  );
};

export const handleError = (error: any) => {
  switch (error?.response?.status) {
    case 400:
      {
        const responseMessages = getResponseMessages(error?.response?.data);
        if (responseMessages.length > 0) {
          responseMessages.forEach((message: string) => {
            notifyError(message);
          });
          //ErrorsDialog({ errors: errors.map((x: any) => x.ErrorMessage) }).then((value) => {});
        } else {
          notifyError(messages(messagesKey.error500));
        }
      }
      break;
    case 401:
      //error auth
      break;
    case 500:
      notifyError(getResponseMessages(error?.response?.data)[0] ?? messages(messagesKey.error500));
      break;
    default:
      if (!axios.isCancel(error)) {
        notifyError(messages(messagesKey.error500));
      }

      break;
  }
  return Promise.reject(error);
};
